import { CellContext } from '@tanstack/react-table';

import { StatusBadge } from '@@/StatusBadge';

import { OmniNodeRowData } from '../types';

import { columnHelper } from './helper';

export const status = columnHelper.accessor((row) => getStatus(row), {
  header: 'Status',
  cell: StatusCell,
});

function StatusCell({
  row: { original: node },
}: CellContext<OmniNodeRowData, string>) {
  const status = getStatus(node);

  const isDeleting =
    node.metadata?.annotations?.['portainer.io/removing-node'] === 'true';
  if (isDeleting) {
    return <StatusBadge color="warning">Removing</StatusBadge>;
  }

  return (
    <div className="inline-flex gap-x-2 whitespace-nowrap">
      <StatusBadge color={status === 'Ready' ? 'success' : 'warning'}>
        {status}
      </StatusBadge>
      {node.spec?.unschedulable && (
        <StatusBadge color="warning">SchedulingDisabled</StatusBadge>
      )}
    </div>
  );
}

function getStatus(node: OmniNodeRowData) {
  return (
    node.status?.conditions?.find((condition) => condition.status === 'True')
      ?.type ?? 'Not ready'
  );
}
